//ecd:1751806438H20261022084009_V3.0
import { request, requestOrNull, seg, Page } from './apiSupport';
import { ItemDTO } from './ItemDTO';
import { ItemKeyDTO } from './ItemKeyDTO';
import { ItemSrchDTO } from './ItemSrchDTO';

/**
 * REST client for Item.
 *
 * Calls the endpoints ItemController exposes. Generated from the same model the
 * server is, so a change to the DSL shows up here as a type error rather than
 * at runtime.
 *
 * Generated by ElastiCORE. Do not edit outside the ElastiCORE guidelines.
 */
const BASE = '/api/petstore/item';

/** Registers a new Item. */
export async function create(input: ItemDTO): Promise<ItemDTO> {
    return request<ItemDTO>('POST', BASE, input);
}

/** The Item with this identifier, or null when there is none. */
export async function findById(itemId: number): Promise<ItemDTO | null> {
    return requestOrNull<ItemDTO>('GET', BASE + '/' + seg(itemId));
}

/** Every Item matching the condition. */
export async function search(condition: ItemSrchDTO): Promise<Page<ItemDTO>> {
    return request<Page<ItemDTO>>('POST', BASE + '/search', condition);
}

/** Updates an existing Item. */
export async function update(input: ItemDTO): Promise<ItemDTO> {
    return request<ItemDTO>('PUT', BASE, input);
}

/** Updates several in one transaction; none are applied if any fails. */
export async function batchUpdate(inputs: ItemDTO[]): Promise<void> {
    return request<void>('PUT', BASE + '/batch', inputs);
}

/** Deletes each key, answering for each whether it was there. */
export async function deleteMany(keys: ItemKeyDTO[]): Promise<boolean[]> {
    return request<boolean[]>('POST', BASE + '/delete', keys);
}

/** Deletes the Item with this identifier. */
export async function deleteById(itemId: number): Promise<boolean> {
    return request<boolean>('DELETE', BASE + '/' + seg(itemId));
}

